import React from 'react'
import classNames from 'classnames'
import styles from '../../../CSS/main.css'
import useMediaQuery from '../../utils/useMediaQuery'
import MobileMenu from './Mobile'
import DesktopMenu from './Desktop'
import { Routes, TypedLink } from '../../routing'

const Navigation: React.VFC = () => {
  const isMobile = useMediaQuery('(max-width: 1027px)')
  const items = (
    <>
      <div className={styles.LinkGroup}>
        {/*<TypedLink className={styles.Link} title='Home' to={Routes.Home}>*/}
        {/*  <span className={classNames([styles.LinkIcon, styles.IconHome])} />*/}
        {/*  <span className={styles.LinkLabel}>Home</span>*/}
        {/*</TypedLink>*/}
        <TypedLink
          className={styles.Link}
          title='Manage Comments'
          to={Routes.Comments}>
          <span
            className={classNames([styles.LinkIcon, styles.IconComments])}
          />
          <span className={styles.LinkLabel}>Comments</span>
        </TypedLink>
        <TypedLink
          className={styles.Link}
          title='Manage Users'
          to={Routes.Users}>
          <span className={classNames([styles.LinkIcon, styles.IconUsers])} />
          <span className={styles.LinkLabel}>Users</span>
        </TypedLink>
        <TypedLink className={styles.Link} title='Manage URLs' to={Routes.URLs}>
          <span className={classNames([styles.LinkIcon, styles.IconURLs])} />
          <span className={styles.LinkLabel}>URLs</span>
        </TypedLink>
        <TypedLink className={styles.Link} title='Manage URLs' to={Routes.FilterWords}>
          <span className={classNames([styles.LinkIcon, styles.IconFilterWords])} />
          <span className={styles.LinkLabel}>Filter Words</span>
        </TypedLink>
        <TypedLink
          className={styles.Link}
          title='Manage Sites'
          to={Routes.Websites}>
          <span
            className={classNames([styles.LinkIcon, styles.IconWebsites])}
          />
          <span className={styles.LinkLabel}>Websites</span>
        </TypedLink>
      </div>
    </>
  )
  return isMobile ? (
    <MobileMenu>{items}</MobileMenu>
  ) : (
    <DesktopMenu>{items}</DesktopMenu>
  )
}

export default Navigation
